import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LogService} from "../../../Core/Abstract/log.service";
import {ConfigService} from "../../../Core/Abstract/config.service";
import {EventsEmitterService} from "../../../Core/Abstract/emitter.service";
import { ActivatedRoute } from "@angular/router";
import { SecurityService } from '../../../Core/Security/security.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { VisualsService } from "../../../Core/Abstract/visuals.service";

@Component({
    selector: 'cloneData',
    templateUrl: 'cloneData.component.html'
})

export class CloneDataComponent implements OnInit {

    @ViewChild('cloneModal',{static: false}) public cloneModal: ModalDirective;
    
    @Input() userList: [];
    @Input() visuals;

    @Output() submitCloneData: EventEmitter<any> = new EventEmitter<any>();

    private cloneForm: FormGroup;
    statusList = [];

    genericYN = this.visualsService.getLkpFromStorageAsJSON("LKP_GENERIC_YN", true);

    constructor(private visualsService: VisualsService , private securityService : SecurityService, private logger: LogService, private fb: FormBuilder,
                private configService: ConfigService, private eventsEmitterService :EventsEmitterService,protected route: ActivatedRoute) {
                      this.statusList = this.visualsService.getLkpFromStorageAsJSON("LKP_REG_USER_S_STATUS",true);
                      
                      this.eventsEmitterService.languageChange.subscribe(langId => {
                        this.statusList = this.visualsService.getLkpFromStorageAsJSON("LKP_REG_USER_S_STATUS",true);
                        this.genericYN = this.visualsService.getLkpFromStorageAsJSON("LKP_GENERIC_YN", true);
                      })
    }

    ngOnInit(): void {
       this.buildForm();
    }

    private buildForm() {
        this.cloneForm = this.fb.group({
            'cloneId' : ['', [Validators.required]],
            'isCopyDocuments': ['', []]
        })
    }

    public submit(){
       let formData = this.cloneForm.value;
       this.submitCloneData.emit(formData);
       this.cloneModal.hide();
    }
}
